import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import _ from "lodash";
import { useState } from "react";
import { ContentPartFilter } from "../../../components/content-part/ContentPartFilter";
import { PageHeader } from "../../../components/page-header";
import { EntBreedingFarm } from "../../../models/breedingFarm";
import { EntBreedingFarmFilter } from "../../../models/filters/breedingFarmFilter";
import { AddBreedingFarmModal } from "./AddBreedingFarmModal";
import { FilterBreedingFarm } from "./FilterBreedingFarm";
import { useBreedingFarm } from "./useBreedingFarm";
import { EmptyData } from "../../../components/empty/emptyData";
import { useTranslation } from "react-i18next";
import { useGetDataOnScroll } from "../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetBreedingFarmListQuery } from "../../../redux/api/breedingFarm/breedingFarmApi";
enum FormField {
  name,
  farmsStatusId,
  animalBreedIds,
  animalTypeIds,
  areaIds,
  regionIds,
  ownerId,
  address,
}


export const BreedingFarms = () => {
  const [modal, contextHolder] = Modal.useModal();
  const [form] = useForm();
  const {t} = useTranslation()
  const [selectedBreedingFarm, setSelectedBreedingFarm] = useState<EntBreedingFarm>(new EntBreedingFarm());
  const [showModal, setShowModal] = useState<boolean>(false);
  const [height, setHeight] = useState<number>(0);
  const openAddModal = (item: EntBreedingFarm) => {
    setSelectedBreedingFarm(item);
    setShowModal(true);
  }
  const [getArchiveFolders] = useLazyGetBreedingFarmListQuery();
  const { onAddBreedingFarm, onEditBreedingFarm, onDeleteBreedingFarm } = useBreedingFarm(modal, () => { searchHandleClick(); })

  const {
    filter,
    fetching,
    data,
    totalItems,
    setData,
    setFetching,
    setFilter,
    scrollHandler,
    setCurrentPage
  } = useGetDataOnScroll<EntBreedingFarm, EntBreedingFarmFilter>({
    initialFilter: new EntBreedingFarmFilter(),
    query: getArchiveFolders
  });

  const setEntityFromFields = (): EntBreedingFarmFilter => {
    let filt: EntBreedingFarmFilter = _.clone(filter);
    filt.name = form.getFieldValue(FormField.name) ?? null;
    filt.farmsStatusId = form.getFieldValue(FormField.farmsStatusId) ?? null;
    filt.animalBreedIds = form.getFieldValue(FormField.animalBreedIds) ?? null;
    filt.animalTypeIds = form.getFieldValue(FormField.animalTypeIds) ?? null;
    filt.areaIds = form.getFieldValue(FormField.areaIds) ?? null;
    filt.regionIds = form.getFieldValue(FormField.regionIds) ?? null;
    filt.ownerId = form.getFieldValue(FormField.ownerId) ?? null;
    filt.address = form.getFieldValue(FormField.address) ?? null;

    return filt;
  }
  const clearFields = () => {
    form.setFields([
      { name: FormField.name, value: null },
      { name: FormField.farmsStatusId, value: null },
      { name: FormField.animalBreedIds, value: null },
      { name: FormField.animalTypeIds, value: null },
      { name: FormField.areaIds, value: null },
      { name: FormField.regionIds, value: null },
      { name: FormField.ownerId, value: null },
      { name: FormField.address, value: null },
    ]);
  }
  const searchHandleClick = () => {
    setFilter(setEntityFromFields());
    setData([]);
    setCurrentPage(0);
    setFetching(true);
  }
  const table = (
    <div style={{ maxHeight: `${height}px`, overflow: 'auto' }} onScroll={scrollHandler}>
      <Spin spinning={fetching}>
      <table>
        <thead>
          <tr>
            <th style={{ width: "40px" }}>#</th>
            <th>{t('general.nameKy')}</th>
            <th>{t('general.nameRu')}</th>
            <th>{ t('breeding_farms.owner') }</th>
            <th>{ t('mechanisation.total_account.address') }</th>
            <th style={{ width: "120px" }}></th>
          </tr>
        </thead>
        <tbody>
          {data.length !== 0 ? data.map((item, index) => (
            <tr key={item.id}>
              <td>{++index}</td>
              <td>{item?.nameKy}</td>
              <td>{item?.nameRu}</td>
              <td>{item?.owner?.secondName} {item?.owner?.name} {item?.owner?.patronymic}</td>
              <td>{item?.address}</td>
              <td>
                <Flex gap="small">
                  <Tooltip title={t('general.edit')}>
                    <Button className='btn_edit' onClick={() => { openAddModal(item) }} type="primary" shape="circle" icon={<EditOutlined />} />
                  </Tooltip>
                  <Tooltip title={ t('general.delete') }>
                    <Button className='btn_edit' danger onClick={() => { onDeleteBreedingFarm(item) }} type="primary" shape="circle" icon={<DeleteOutlined />} />
                  </Tooltip>
                </Flex>
              </td>
            </tr>
          )
          )
            : <tr>
              <td colSpan={6}>
                <EmptyData />
              </td>

            </tr>}
        </tbody>
      </table>
      </Spin>
    </div>
  );
  return (
    <>
      <PageHeader
        title={ t('titles.register_of_breefingfaerm') }
        additionalInfo={
          <Typography.Text style={{ marginBottom: '0.5em', display: 'block' }} type="secondary">
            {t('breeding_farms.phif_desc')}.  {t('general.records_found')} {totalItems}</Typography.Text>
        } />
      <Button type="primary" icon={<PlusOutlined />} onClick={() => { openAddModal(new EntBreedingFarm()) }}>
        { t('breeding_farms.add_phif') }
      </Button>
      <Spin spinning={fetching}>
      <ContentPartFilter
        filter={<FilterBreedingFarm   onSearch={searchHandleClick}
        onReset={() => { clearFields(); searchHandleClick() }} formField={FormField} form={form} />}
        setHeight={setHeight}
        table={table}
      
      />
      </Spin>
      <AddBreedingFarmModal
        breedingFarm={selectedBreedingFarm}
        show={showModal}
        onHide={() => {
          setShowModal(false)
          setSelectedBreedingFarm(new EntBreedingFarm())
        }}
        onSubmit={selectedBreedingFarm.id !== 0 ? onEditBreedingFarm : onAddBreedingFarm}
      />
      {contextHolder}
    </>
  )
}
